import React from "react";

import chevronLeft from '../../assets/svgs/avatr/chevron-left.svg'
import chevronRight from '../../assets/svgs/avatr/chevron-right.svg'
import { InteriorData } from "../../data/interior.data";

// TEMPORAL: visor de imágenes que reemplaza la vista interior 3D.
// Se muestra mientras la vista sea "Interior". Para volver al comportamiento anterior
// ver el bloque "TEMPORAL (visor interior)" en studio.component.tsx.

interface InteriorViewerProps {
  car: any;
  visible: boolean;
  isPortrait: boolean;
  isCollapsed: boolean;
}

const InteriorViewer: React.FC<InteriorViewerProps> = ({ car, visible, isPortrait, isCollapsed }) => {

  const images: string[] = React.useMemo(() => {
    const interiorData: any = InteriorData();
    return (interiorData[car?.id] || []).map((image: any) => image?.default || image);
  }, [car]);

  const [index, setIndex] = React.useState(0);
  const touchStartX = React.useRef<number | null>(null);

  React.useEffect(() => {
    if(visible)
      setIndex(0);
  }, [visible, car]);

  const Previous = React.useCallback(() => {
    setIndex((prev) => (prev - 1 + images.length) % images.length);
  }, [images]);

  const Next = React.useCallback(() => {
    setIndex((prev) => (prev + 1) % images.length);
  }, [images]);

  // Flechas del teclado en computador
  React.useEffect(() => {
    if(!visible)
      return;
    const onKeyDown = (e: KeyboardEvent) => {
      if(e.key === 'ArrowLeft') Previous();
      if(e.key === 'ArrowRight') Next();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [visible, Previous, Next]);

  // Deslizar en celular
  const onTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const onTouchEnd = (e: React.TouchEvent) => {
    if(touchStartX.current === null)
      return;
    const deltaX = e.changedTouches[0].clientX - touchStartX.current;
    touchStartX.current = null;
    if(deltaX < -50) Next();
    else if(deltaX > 50) Previous();
  };

  return (
    <div className={`interior-viewer ${visible ? '' : 'hide'} ${isPortrait ? 'portrait' : ''} ${isCollapsed ? 'extended' : ''}`}
         onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
      <div className={`interior-viewer-stage ${isPortrait ? 'portrait' : ''}`}>
        {images.map((image: string, i: number) =>
          <img key={image} className={`interior-viewer-image ${i === index ? 'visible' : ''} ${isPortrait ? 'portrait' : ''}`} src={image} draggable={false} alt="" />
        )}
      </div>

      <div className={`interior-viewer-controls ${isPortrait ? 'portrait' : ''}`}>
        <div className={`interior-viewer-button`} onClick={() => {Previous()}}>
          <img src={chevronLeft} draggable={false} alt=''/>
        </div>
        <div className={`interior-viewer-indicators`}>
          {images.map((image: string, i: number) =>
            <div key={image} className={`interior-viewer-indicator ${i === index ? 'selected' : ''}`} onClick={() => {setIndex(i)}}>
              <div className={`interior-viewer-indicator-line`}/>
            </div>
          )}
        </div>
        <div className={`interior-viewer-counter`}>{`${index + 1} / ${images.length}`}</div>
        <div className={`interior-viewer-button`} onClick={() => {Next()}}>
          <img src={chevronRight} draggable={false} alt=''/>
        </div>
      </div>
    </div>
  );
};

export default InteriorViewer;
